"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jwt_1 = tslib_1.__importDefault(require("../../tools/jwt"));
function auth(to, from, next) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        console.group('auth');
        try {
            console.log('Retrieving JWT...');
            yield jwt_1.default.retrieve();
        }
        catch (e) {
            console.log('JWT check failed, redirecting to login page...');
            console.groupEnd();
            const params = {
                redirect: null,
            };
            if (to.path !== 'login') {
                console.log(`Create redirect to ${to.fullPath} after login`);
                params.redirect = to.fullPath;
            }
            return next({
                name: 'login',
                params: Object.assign({}, params),
            });
        }
        console.log('JWT is OK.');
        console.groupEnd();
        return next();
    });
}
exports.default = auth;
//# sourceMappingURL=auth.js.map